import React from "react";
import MarketingNav from "@/components/MarketingNav";
import Footer from "@/components/Footer";

const ARTICLES = [
  { tag: "Playbook", title: "Delaware vs. Singapore: where should your SaaS incorporate?",
    blurb: "A decision framework for founders choosing between Delaware C-Corp and Singapore Pte Ltd.", time: "8 min" },
  { tag: "Guide", title: "The UAE Free Zone decision tree",
    blurb: "IFZA, DMCC, ADGM, DIFC — which free zone matches your business, and why the difference matters.", time: "11 min" },
  { tag: "Deep dive", title: "The BOI reporting tsunami hitting US entities",
    blurb: "What the FinCEN Beneficial Ownership Information rule means, and how to prepare for it.", time: "6 min" },
  { tag: "How-to", title: "Closing your first year of compliance — a 20-point checklist",
    blurb: "From AGM filings to statutory registers, a pragmatic guide to year-end across major jurisdictions.", time: "14 min" },
  { tag: "Playbook", title: "Cap-table sanity for multi-country groups",
    blurb: "How holding-company structures across Estonia, Singapore and the US actually work.", time: "9 min" },
  { tag: "Guide", title: "Estonia e-Residency is not what you think it is",
    blurb: "What it gets you, what it doesn't, and who should actually bother.", time: "7 min" },
];

const Resources = () => (
  <div className="bg-surface-app min-h-screen text-ink-body">
    <MarketingNav />
    <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 pt-16 pb-12">
      <div className="text-xs uppercase tracking-[0.28em] text-ink-muted font-mono-accent mb-6">Resources</div>
      <h1 className="h-display text-5xl md:text-7xl max-w-3xl">Field notes from the <span className="italic text-artha-amber">compliance frontier</span>.</h1>
    </section>

    <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 pb-24 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-artha-light-border border border-border-subtle">
      {ARTICLES.map((a, i) => (
        <article key={i} data-testid={`article-${i}`} className="bg-surface-card p-10 hover:bg-surface-app transition-colors flex flex-col">
          <div className="text-[10px] uppercase tracking-[0.28em] font-mono-accent text-artha-amber">{a.tag}</div>
          <h2 className="h-display text-2xl md:text-3xl mt-4 leading-tight">{a.title}</h2>
          <p className="text-sm text-ink-muted mt-4 leading-relaxed">{a.blurb}</p>
          <div className="mt-auto pt-8 text-xs font-mono-accent uppercase tracking-[0.2em] text-ink-muted">Read · {a.time}</div>
        </article>
      ))}
    </section>
    <Footer />
  </div>
);

export default Resources;
